import { render, staticRenderFns } from "./PpvDateFilter.vue?vue&type=template&id=06dff772&scoped=true"
import script from "./PpvDateFilter.vue?vue&type=script&lang=js"
export * from "./PpvDateFilter.vue?vue&type=script&lang=js"
import style0 from "./PpvDateFilter.vue?vue&type=style&index=0&id=06dff772&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06dff772",
  null
  
)

export default component.exports